/* Grondyke Soap Co. · Durden 2 pre-order · /pages/durden-2

   Three behaviours, all progressive: without this file the page still reads, the FAQ answers are
   all visible, and every CTA is a working anchor.

   1 · Add to cart. Each package button carries its own variant id and posts to cart/add.js
   through Eurus's own drawer pipeline (xCartHelper section re-render + xMiniCart.openCart), the
   same path the PDP and the starter sets use, so the regular cart drawer opens with the package
   in it. The button locks while the request is in flight, a failure shows an inline message and
   unlocks, and success is only announced once Shopify has confirmed the line. Without the Eurus
   stores it falls back to the cart page. Draft products render a disabled button with no id, so
   nothing here runs for them.

   2 · FAQ. Single-open accordion, first item open from the markup.

   3 · Sticky bar. Slides in once the hero's bottom edge leaves the viewport and hides again while
   the packages section is on screen, because its buttons are already visible. Same rule at every
   width. It only ever anchors to the selector; it never adds the set. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gk-d2]');
  if (!root) return;

  // 1 · Add to cart ────────────────────────────────────────────────────────────────────────
  function drawerReady() {
    var A = window.Alpine;
    return !!(A && A.store && A.store('xCartHelper') && A.store('xMiniCart') && window.fetch);
  }

  function addVariant(btn) {
    var variantId = Number(btn.getAttribute('data-d2-add'));
    if (!variantId || btn.disabled) return;

    var errorEl = root.querySelector('[data-d2-err]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-d2-add]'));
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var useDrawer = drawerReady();
    var helper = useDrawer ? window.Alpine.store('xCartHelper') : null;
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (useDrawer) {
      body.sections = helper.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var start = useDrawer ? helper.waitForCartUpdate() : Promise.resolve();
    start.then(function () {
      if (useDrawer) window.updatingCart = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; });
    }).then(function (res) {
      if (!res.ok || (res.json.status && res.json.status >= 400)) {
        throw new Error(res.json.description || res.json.message || 'Could not add this package.');
      }
      var added = res.json.items ? res.json.items[0] : res.json;
      if (!added || Number(added.variant_id || added.id) !== variantId) {
        throw new Error('This package was not added. Please try again.');
      }
      if (useDrawer) {
        helper.reRenderSections(res.json.sections);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10) || helper.currentItemCount;
        window.Alpine.store('xMiniCart').openCart();
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: added } }));
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      if (errorEl) { errorEl.textContent = err.message || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
    }).then(function () {
      if (useDrawer) window.updatingCart = false;
      buttons.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
    });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-d2-add]') : null;
    if (btn && root.contains(btn)) { e.preventDefault(); addVariant(btn); }
  });

  // 2 · FAQ ────────────────────────────────────────────────────────────────────────────────
  var faq = root.querySelector('[data-d2-faq]');
  if (faq) {
    faq.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-d2-q]') : null;
      if (!btn || !faq.contains(btn)) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      Array.prototype.forEach.call(faq.querySelectorAll('[data-d2-q]'), function (b) {
        b.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      }
    });
  }

  // 3 · Sticky bar ─────────────────────────────────────────────────────────────────────────
  var bar = root.querySelector('[data-d2-sticky]');
  var hero = root.querySelector('[data-d2-hero]');
  var packages = root.querySelector('#packages');
  if (bar && hero && packages) {
    var shown = false;
    var ticking = false;
    var evaluate = function () {
      ticking = false;
      var vh = window.innerHeight;
      var heroBottom = hero.getBoundingClientRect().bottom;
      var pr = packages.getBoundingClientRect();
      var inPackages = pr.top < vh * 0.6 && pr.bottom > vh * 0.4;
      var show = heroBottom < 0 && !inPackages;
      if (show !== shown) { shown = show; bar.classList.toggle('is-on', show); }
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    evaluate();
  }
})();
